import { useTranslation } from 'Components/Helpers/translate';
import { SlideFade } from '@upsales/components/animations';
import BemClass from '@upsales/components/Utils/bemClass';
import colorMappings from '@upsales/components/Utils/colorMappings';
import { Flex, Text, Icon } from '@upsales/components';
import React, { useState } from 'react';

import './Reasonings.scss';

const MAIN_COLOR = 'grey-10';

const Reasonings = ({ reasonings }: { reasonings: string[] }) => {
	const classes = new BemClass('Reasonings');
	const { t } = useTranslation();

	const [isOpen, setIsOpen] = useState(true);
	const toggle = () => setIsOpen(!isOpen);
	if (reasonings.length === 0) return null;

	return (
		<Flex
			className={classes.b()}
			direction="column"
			onClick={toggle}
			style={{ '--main-color': colorMappings.get(MAIN_COLOR) } as React.CSSProperties}
		>
			<Flex gap="u2" className={classes.elem('header').b()} alignItems="center">
				<Text size="md" color={MAIN_COLOR}>
					{t('aiChat.loading.reasoning')}
				</Text>
				<Icon
					color={MAIN_COLOR}
					name="chevron-down"
					className={classes.elem('header').elem('chevron').mod({ open: isOpen }).b()}
				/>
			</Flex>
			<SlideFade visible={isOpen} height maxHeight={reasonings.length * 20}>
				<Flex direction="column" gap="u1" className={classes.elem('reasonings').b()} spacing="pl2 mt2">
					{reasonings.map((reasoning, idx) => (
						<Text
							key={idx}
							size="sm"
							color={MAIN_COLOR}
							className={classes.elem('reasonings').elem('reasoning').b()}
						>
							{`${idx + 1}. ${reasoning}`}
						</Text>
					))}
				</Flex>
			</SlideFade>
		</Flex>
	);
};

export default Reasonings;
